// import { Dcoptions, Pieoptions, WorkAssign } from "../../../Helper/Data"
import React, { useEffect, useState } from 'react'
import { useAuthState } from '../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import WTPMasterCardManage from './WTPDashboardComponent/WTPMasterCard/WTPMasterCardManage';
import WTPDataUploadCardManage from './WTPDashboardComponent/WTPDataUPload/WTPDataUploadCardManage';
import WTPPreventiveDataCardManage from './WTPDashboardComponent/WTPPreventiveData/WTPPreventiveDataCardManage';
import WTPAssignMainWorkCardManage from './WTPDashboardComponent/WTPAssignMaintainanceWork/WTPAssignedMaintainanceWorkCardManage';



export const WTPDashboard = ({ DashProjectTypeId,YearValue,YearLabel,MonthValue,MonthLabel,WardValue,WardLabel,ProjectTypeId,DashboardName,Countdata ,WTPMasterCountData}) => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [ActiveClass, setActiveClass] = useState('Distribution')

  

    return (
        <>
            <div>
                <div className="m-1 py-2 pb-4 master_border">
                    <WTPMasterCardManage
                        Countdata={Countdata}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ProjectTypeId={ProjectTypeId}
                        DashboardName={DashboardName}
                        DashProjectTypeId={DashProjectTypeId}
                        WTPMasterCountData={WTPMasterCountData}
                       
                    />
                </div>

                <div className="m-1 py-2 mt-4 pb-4 master_border">
                    <WTPDataUploadCardManage
                        Countdata={Countdata}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ProjectTypeId={ProjectTypeId}
                        DashboardName={DashboardName}
                        DashProjectTypeId={DashProjectTypeId}
                        WTPMasterCountData={WTPMasterCountData}
                       
                    />
                </div>

                <div className="m-1 py-2 mt-4 pb-4 master_border">
                    <WTPPreventiveDataCardManage
                        Countdata={Countdata}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ProjectTypeId={ProjectTypeId}
                        DashboardName={DashboardName}
                        DashProjectTypeId={DashProjectTypeId}
                        WTPMasterCountData={WTPMasterCountData}

                       
                    />
                </div>

                <div className="m-1 py-2 mt-4 pb-4 master_border">
                    <WTPAssignMainWorkCardManage
                        Countdata={Countdata}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ProjectTypeId={ProjectTypeId}
                        DashboardName={DashboardName}
                        DashProjectTypeId={DashProjectTypeId}
                        WTPMasterCountData={WTPMasterCountData}

                      
                    />
                </div>

            </div>
        </>
    )
}
